"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireImage = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const Text_1 = __importDefault(require("./Text"));
const styles_1 = require("../styles");
const requireImage = (image) => {
    if (react_native_1.Platform.OS === 'web') {
        return image.default;
    }
    return image;
};
exports.requireImage = requireImage;
const headerPattern = exports.requireImage(require('../../assets/headerPattern.png'));
const arrowLeft = require('../../assets/arrowLeft.png');
const Header = ({ title }) => {
    const { goBack } = native_1.useNavigation();
    return (react_1.default.createElement(react_native_1.ImageBackground, { style: styles.headerPatternImageView, resizeMode: "cover", source: headerPattern },
        react_1.default.createElement(react_native_1.View, { style: styles.innerContainer },
            react_1.default.createElement(Text_1.default, { margin: "none", variant: "title" }, title),
            react_1.default.createElement(react_native_1.Pressable, { onPress: goBack },
                react_1.default.createElement(react_native_1.Image, { resizeMode: "contain", source: arrowLeft, style: styles.chevronLeft })))));
};
exports.default = Header;
const styles = react_native_1.StyleSheet.create({
    headerPatternImageView: {
        height: 60,
        width: '100%',
    },
    innerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: styles_1.getSpacing(),
        marginTop: styles_1.getSpacing(),
    },
    chevronLeft: {
        width: 20,
        height: 20,
    },
});
